import { TextField, useTheme } from '@mui/material';

export const InputFiled = ({
  isEditContactData,
  errorPhone,
  nameFiled,
  info,
  funtion,
  errorAddress,
}) => {
  const theme = useTheme();
  return (
    <>
      <TextField
        disabled={true}
        label={nameFiled}
        variant='filled'
        name='email'
        value={info}
        onChange={e => funtion(e)}
        sx={{
          width: { sm: '48%' },
          flex: { sm: '1 1 308px', xs: '1 1 100%' },
          boxSizing: 'border-box',
          backgroundColor: theme.palette.primary.textLightBlue,
          '& .MuiInputLabel-root': {
            fontSize: theme.typography.description.fontSize,
          },
          '& .MuiInputBase-input': {
            fontSize: theme.typography.description.fontSize,
          },
          '& .MuiFilledInput-root': {
            backgroundColor: theme.palette.primary.textLightBlue,
          },
          '& .MuiFilledInput-root.Mui-disabled': {
            backgroundColor: theme.palette.primary.textLightBlue,
            color: theme.palette.primary.textLightBlue,
          },
        }}
      />
    </>
  );
};
